export default "__VITE_ASSET__DOHP25vf__"